import React from 'react';
import styles from './dealDetails.scss';

interface IProps {
  label?: string,
  value: React.ReactNode | string,
}

const Detail = ({ label, value }: IProps) => (
  !!value && (
    <div className={ styles.detail }>
      <div className={ styles.detailLabel }>{ label }</div>
      <div className={ styles.detailText }>{ value }</div>
    </div>
  )
);

export default React.memo(Detail);
